/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![WidgetsRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABm0lEQVR4nM1UTUsDQQydk0cvKh6EivW3qKU7maSFMWnFf+CpfuFVEGt/kaJeLP6USg9aD57qpZKtW9a63e6ugj4YWGYfeckkecb8ZxDxJqCcWOQja30pley9X3DEV4D85EhG0QHiniNp6/843xJvA/L7hIcyBJROpbK3mCigQeKBE0474moQR9xP5nFfxb8JfGY6UwCIexMuSieVizIM6s3ydAWjeccYY6r15roGmMfV3hQSAJTDLFxH3CoowKcZsh9qpYV6ENSb5XlPpD3KPUWAchkf0bQpShzV8R5Ie7oSmLEHGkQzjVcT7kJNtsxvwlpf0k12xMcAfsP8GXxOq8iNPFYRB9SkAsTXjngAKG+O5A5xdwdIHh1yt5BVRHAk51l2J9eiRUBsVMeTo47KLWsby0Hg14DkLO6yhQWA5HbaEsJn+a0KAOVF7zTzSQzk7tdnlYfCPXDEA70n2l8yWZDHKhQO+T7RNWchr1UAsY2arJsMIKsV71fCb+JXID7IJJwGR3KR8qQ/FwhFahLoRAHyc9h4lBtdtIjwAVQHR+B1zHD/AAAAAElFTkSuQmCC)
 */
export const WidgetsRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M18.45 1.85a3 3 0 0 0-4.1 1.1l-1.5 2.6a3 3 0 0 0 1.1 4.1l2.6 1.5a3 3 0 0 0 4.1-1.1l1.5-2.6a3 3 0 0 0-1.1-4.1l-2.6-1.5ZM2 5a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5ZM2 16a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-3ZM19 16a3 3 0 1 0 1.98 5.25 1 1 0 1 1 1.33 1.5A4.99 4.99 0 0 1 14 19a5 5 0 0 1 8-4 1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h1.24A3 3 0 0 0 19 16Z"
        className={colorClass}
      />
    </svg>
  );
};
